import { Component } from '@theme/component';

const desktopQuery = window.matchMedia('(min-width: 750px)');

let motionModule = null;
async function loadMotion() {
  if (motionModule) return motionModule;
  motionModule = window.Motion || await import(new URL('motion.js', import.meta.url).href).then(() => window.Motion);
  return motionModule;
}

class ParallaxQuote extends Component {
  #animation = null;

  get start() {
    return this.getAttribute("data-start") || '0%';
  }

  get end() {
    return this.getAttribute("data-end") || '0%';
  }

  connectedCallback() {
    this.initAnimation();

    window.addEventListener('resize', () => {
      this.initAnimation();
    }, { passive: true })
  }

  async initAnimation() {
    if (!desktopQuery.matches) {
      if (this.#animation) {
        this.#animation();
        this.#animation = null;
      }
      return;
    }

    if (this.#animation != null) {
      return;
    }

    const Motion = await loadMotion();
    if (!Motion) return;

    this.#animation = Motion.scroll(Motion.animate(this, {
      '--translate-y': [this.start, this.end],
    }), {
      target: this,
    });
  }
}

if (!customElements.get('parallax-quote')) {
  customElements.define('parallax-quote', ParallaxQuote);
}